/* nad-firming.js — plantilla NAD+ Firming Serum
   Lo cargan todas las secciones NAD+; está protegido para correr una sola vez. */
(function () {
  if (window.__nadInit) return;
  window.__nadInit = true;

  function each(sel, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---- Cuenta regresiva: termina a medianoche hora de Lima (UTC-5) ---- */
  function tick() {
    var day = 864e5;
    var lima = Date.now() - 5 * 3600e3;
    var left = Math.floor((day - (lima % day)) / 1000);
    each('[data-nad-h]', function (el) { el.textContent = pad(Math.floor(left / 3600)); });
    each('[data-nad-m]', function (el) { el.textContent = pad(Math.floor((left % 3600) / 60)); });
    each('[data-nad-s]', function (el) { el.textContent = pad(left % 60); });
  }
  var timerOn = false;
  function startTimer() {
    if (timerOn) return;
    timerOn = true;
    tick();
    setInterval(tick, 1000);
  }

  /* ---- La barra se coloca encima del header (no en el editor de temas) ---- */
  function moveTopbar() {
    if (designMode) return;
    each('[data-nad-topbar][data-move-top="true"]', function (bar) {
      if (bar.__nadMoved) return;
      bar.__nadMoved = true;
      var sec = bar.closest('.shopify-section') || bar;
      var header = document.querySelector('.shopify-section-group-header-group');
      if (header && header.parentNode) header.parentNode.insertBefore(sec, header);
    });
  }

  /* ---- Ofertas: mantienen sincronizado el formulario nativo que lee Releasit ---- */
  function initOffers() {
    each('[data-nad-product]', function (root) {
      var box = root.querySelector('[data-nad-offers]');
      if (!box) return;
      var select = root.querySelector('[data-nad-variant-input]');
      var qtyInput = root.querySelector('[data-nad-qty-input]');

      function pick(card) {
        each('[data-nad-offer]', function (c) {
          var on = c === card;
          c.classList.toggle('is-on', on);
          var i = c.querySelector('input');
          if (i) i.checked = on;
        }, box);
        var id = card.getAttribute('data-variant-id');
        var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
        if (!id) return;
        if (select && select.value !== id) {
          select.value = id;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (qtyInput && String(qtyInput.value) !== String(qty)) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* Solo se reescribe el enlace si el botón va al checkout de Shopify.
           En modo Releasit el enlace /rsi-btn-hook no se toca. */
        each('[data-nad-buy]', function (b) {
          if (b.getAttribute('data-mode') === 'checkout') b.setAttribute('href', '/cart/' + id + ':' + qty);
        });
      }

      each('[data-nad-offer]', function (card) {
        if (card.__nadBound) return;
        card.__nadBound = true;
        var input = card.querySelector('input');
        if (input) input.addEventListener('change', function () { pick(card); });
        card.addEventListener('click', function () { pick(card); });
      }, box);

      var first = box.querySelector('[data-nad-offer].is-on') || box.querySelector('[data-nad-offer]');
      if (first) pick(first);
    });
  }

  /* ---- Galería ---- */
  function initGallery() {
    each('[data-nad-gallery]', function (gal) {
      var track = gal.querySelector('[data-nad-track]');
      var thumbs = gal.querySelectorAll('[data-nad-thumb]');
      if (!track) return;
      Array.prototype.forEach.call(thumbs, function (t) {
        if (t.__nadBound) return;
        t.__nadBound = true;
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-nad-thumb'), 10) || 0;
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
      if (track.__nadBound) return;
      track.__nadBound = true;
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          Array.prototype.forEach.call(thumbs, function (t, j) { t.classList.toggle('is-on', i === j); });
        });
      }, { passive: true });
    });
  }

  /* ---- Porcentajes que suben al aparecer en pantalla ---- */
  function initCounters() {
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var to = parseFloat(el.getAttribute('data-nad-count')) || 0;
        var t0 = null;
        function run(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 1400);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(run);
        }
        requestAnimationFrame(run);
      });
    }, { threshold: 0.6 });
    each('[data-nad-count]', function (el) {
      if (el.__nadBound) return;
      el.__nadBound = true;
      io.observe(el);
    });
  }

  /* ---- Carrusel de reseñas ---- */
  function initCarousels() {
    each('[data-nad-carousel]', function (car) {
      var track = car.querySelector('[data-nad-rtrack]');
      if (!track) return;
      function step() {
        var c = track.firstElementChild;
        return c ? c.getBoundingClientRect().width + 16 : 300;
      }
      each('[data-nad-prev]', function (b) {
        if (b.__nadBound) return;
        b.__nadBound = true;
        b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      }, car);
      each('[data-nad-next]', function (b) {
        if (b.__nadBound) return;
        b.__nadBound = true;
        b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      }, car);
    });
  }

  function init() {
    startTimer();
    tick();
    moveTopbar();
    initOffers();
    initGallery();
    initCounters();
    initCarousels();
  }

  ready(init);
  /* El editor de temas vuelve a dibujar las secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', init);
})();
